var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdf-modal-wrapper" },
    [
      _vm.boundingBox && _vm.currentPage
        ? _c("canvas", {
            style: {
              left: _vm.originX + _vm.offsetLeft + "px",
              top: _vm.originY + "px"
            },
            attrs: {
              id: "provenance-overlay",
              width: _vm.width,
              height: _vm.height
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "header-styling" }, [
        _c("div", { staticClass: "btn-wrapper" }, [
          _c(
            "div",
            { staticClass: "btn-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "action-btn",
                  attrs: { height: "40" },
                  on: { click: this.goBack }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "fa-regular fa-arrow-left", size: "2x" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.fetchedPages[_vm.pageIndex] &&
              _vm.fetchedPages[_vm.pageIndex].page
                ? _c("div", { staticClass: "pdf-title" }, [
                    _vm._v("\n          " + _vm._s(_vm.name) + "\n        ")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "action-btn",
                  attrs: { height: "40" },
                  on: { click: this.download }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "fa-regular fa-download", size: "2x" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isSharedProfileView && !this.$route.query.viewShareOption
                ? _c(
                    "v-btn",
                    {
                      staticClass: "action-btn",
                      attrs: { height: "40" },
                      on: { click: this.toggleSharingModal }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "fa-regular fa-share", size: "2x" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _vm._v("No Preview Available")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentPage
        ? _c("div", { staticClass: "card-img", attrs: { else: "" } }, [
            _c("img", {
              ref: "documentImage",
              staticClass: "img-container",
              attrs: { src: _vm.currentPage }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentPage && !(_vm.disableLeft && _vm.disableRight)
        ? _c(
            "div",
            { staticClass: "previous-next-btn-wrapper" },
            [
              !_vm.disableLeft
                ? _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("prevPage")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: "fa-solid fa-circle-chevron-left",
                          size: "2x"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.disableRight
                ? _c(
                    "v-btn",
                    {
                      staticStyle: { float: "right" },
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("nextPage")
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: "fa-solid fa-circle-chevron-right",
                          size: "2x"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-footer", { attrs: { fixed: "", color: "#000", height: "50" } }),
      _vm._v(" "),
      _c("ShareModel", {
        attrs: {
          opened: _vm.shareModalOpened,
          userId: _vm.getUserId,
          documentToShare: _vm.doc
        },
        on: { toggleSharingModal: _vm.toggleSharingModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }